import { computed, signal } from "@preact/signals-react"

export const CatalogueDetailsIsEmpty = signal(false)
export const CatalogueDetailsPriceEvolutionFilters = signal({})
export const CatalogueDetailsStockEvolutionFilters = signal({})
export const catalogueDetailsCurrentPeriod = signal("")
export const catalogueDetailsEndDate = signal("")
export const catalogueDetailsTableData = signal([])
export const catalogueDetailsSkuMappingData = signal([])
 
export const catalogueDetailsFormRowDataMultiple = signal({})
export const catalogueDetailsFormRowData = signal({})
export const catalogueDetailsFormTitle = signal(null)
export const catalogueDetailsErrorFormData = signal({})
export const catalogueDetailsFormIsLoading = signal(null)
export const catalogueDetailsFormIsSkuMappingData = signal(false)
export const brandForm = signal([])
export const skuForm = signal([])
export const siteForm = signal([])

// Computed
export const catalogueDetailsFormIsOpen = computed(() => catalogueDetailsFormTitle.value !== null)